<template>
  <div class="registered-icon">
    <el-tooltip :content="tooltipText">
      <i :class="registeredIcon" />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'RegisteredIcon',
  props: {
    isRegistered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltipText() {
      return this.isRegistered ? 'This email has not been Registered' : 'This email is Registered'
    },

    registeredIcon() {
      return this.isRegistered ? 'el-icon-success' : 'el-icon-error'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .registered-icon {
    text-align: center;
    font-size: 24px;
  }

  .el-icon-success {
    color: $-color-success;
  }

  .el-icon-error {
    color: $-color-error;
  }
</style>
